import * as React from 'react';
import { ArticleItem } from 'types';
import { formatDate } from 'utils/formatting';
import t from 'utils/translations';
import {
    apiGetAppointmentArticleById,
    apiGetTalentArticle
} from 'api/publications';
import { ArticleModalElement } from 'components/common/ArticleModalElement';
import { FeedItem } from 'components/context/types';

interface Props {
    id: string;
    source: string;
}

const initialArticle: FeedItem = {
    title: '',
    content: '',
    companyIds: [],
    published: '',
    source: ''
};

const errorHasOccurred = (error: string) => error !== '';

export default function ArticleModalContent({ id, source }: Props) {
    const [article, setArticle] = React.useState<FeedItem>(initialArticle);
    const [apiError, setApiError] = React.useState<string>('');

    const publishedDate = (article && article.published) || '';
    const publishedFormatted = formatDate(publishedDate);
    const modifiedFormatted = formatDate((article && article.modified) || '');
    const content = (article && article.content) || '';
    const title = (article && article.title) || '';
    const businessIds = (article && article.companyIds) || [];
    const uri = (article && article.uri) || '';

    React.useEffect(() => {
        if (source === 'Appointment') {
            apiGetAppointmentArticleById(id)
                .then((response: Response) => {
                    return response.json();
                })
                .then((article: ArticleItem) => {
                    setArticle(article);
                })
                .catch(({ status }) => {
                    setArticle(initialArticle);
                    setApiError(`${t('API_ERROR_OCCURRED')}: ${status}`);
                });
        } else {
            apiGetTalentArticle(source, id)
                .then((response: Response) => {
                    return response.json();
                })
                .then((articleResponse: ArticleItem) => {
                    setArticle(articleResponse);
                })
                .catch(({ status }) => {
                    setArticle(initialArticle);
                    setApiError(`${t('API_ERROR_OCCURRED')}: ${status}`);
                });
        }
    }, [id, source]);

    if (errorHasOccurred(apiError)) {
        return (
            <div>
                <p>{apiError}</p>
            </div>
        );
    }
    return (
        <ArticleModalElement
            title={title}
            published={publishedFormatted}
            modified={modifiedFormatted}
            content={content}
            businessIds={businessIds}
            uri={uri}
            source={source}
        />
    );
}
